import { Component, OnInit, Input } from '@angular/core';
import { take } from 'rxjs/operators';
import { EnumerationService } from '../../../services/enumeration/enumeration.service';
import { SchemaField, Document, EnumerationValue } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-enumeration-column',
    templateUrl: './enumeration-column.component.html',
    styleUrls: ['./enumeration-column.component.scss'],
    standalone: false
})
export class EnumerationColumnComponent implements OnInit, DynamicColumn {
  _field: SchemaField;
  _document: Document;


  @Input() set field(value: SchemaField) {
    this._field = value;
    if (!!this._document) {
      this.setFieldValue();
    }
  }
  @Input() set document(value: Document) {
    this._document = value;
    if (!!this._field) {
      this.setFieldValue();
    }
  }

  fieldValue: string;

  constructor(private enumerationService: EnumerationService) {}

  ngOnInit(): void {}

  private setFieldValue(): string {
    const value = this._document?.[this._field.systemName];

    const selectedEnumerationItemUId = value;
    if (!selectedEnumerationItemUId) {
      this.fieldValue = '';
      return;
    }

    const values = [];

    value?.map(id => {
      const selectedEnumItem = this._field.enumerationValues?.find(p => p.uId === id) as EnumerationValue;
      if (selectedEnumItem) {
        values.push(selectedEnumItem.name);
      }
    });
    this.fieldValue = values.join(', ');

/*    this.enumerationService.getEnumerationValues(this._field)
    .pipe(take(1))
    .subscribe(enumerationValues => {
      const selectedEnumerationItem = enumerationValues?.find(p => p.uId === selectedEnumerationItemUId) as EnumerationValue;
      this.fieldValue = selectedEnumerationItem?.value;
    });*/
  }
}
